module.exports = __webpack_public_path__ + "img/ulaval-logo.22847c4c.png";